import React from "react";
import "./Maple.scss";
import data from "./data.json";
import Card from "../../Component/Card/card";
import Maple12images from "../../Media/Summarecon Bogor/Maple12";
import Maple15images from "../../Media/Summarecon Bogor/Maple15";

const imageMap = {
  Maple12images,
  Maple15images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Ebony" className="produk">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
